import { useRef, useState } from 'react';
import TextField from '@mui/material/TextField';
import { bytesToSize } from '../services/helpers';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import { FormHelperText } from '@mui/material';
import { Dialog, DialogActions, DialogContent, Divider } from '@mui/material';
import { toImageSrc } from '../services/imageSrc';

const mimeTypes = ['image/jpg', 'image/png', 'image/jpeg'];

export default function AddImage({ onChange, value, label, colorLabel, name, canvaWidth, canvaHeight, objectFit = 'cover', required = false }) {
    const refInputFile = useRef(null);

    const [preview, setPreview] = useState();
    const [image, setImage] = useState();
    const recommendedText = `Dimensões recomendadas: ${canvaWidth || 300}x${canvaHeight || 220}px. Formato PNG.`;
    const tipText = 'Para um visual mais limpo, use PNG com fundo transparente (remova o fundo) e centralize o logo/assunto.';
    const displaySrc = toImageSrc(value);

    const handleFile = data => {
        if (!data) return;
        if (!mimeTypes.includes(data.type)) {
            alert('Tipo de arquivo não suportado');
            return;
        }
        if (data.size > 5000000) {
            alert(`${bytesToSize(data.size)} ${data.size} Arquivo maior que 5Mb. Tente reduzir o arquivo.`);
            return;
        }

        let reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onload = function () {
            const base64 = reader.result.replace(/^data:image\/(?:gif|png|jpeg|jpg|bmp|webp)(?:;charset=utf-8)?;base64,/, '');
            setImage(base64);
            setPreview(URL.createObjectURL(data));
        };
        reader.onerror = function () {
            alert('Erro ao inserir a imagem');
        };
    };

    const handleOpen = () => {
        if (refInputFile.current) {
            refInputFile.current.click();
        }
    };

    return (
        <Stack gap={1} sx={{ mb: 2 }}>
            <Stack alignItems="center">
                {displaySrc ? (
                    <>
                        <Box
                            component="img"
                            src={displaySrc}
                            sx={{
                                marginLeft: 'auto',
                                borderRadius: 1,
                                border: 'solid 1px #ccc',
                                marginRight: 'auto',
                                width: canvaWidth || 300,
                                height: canvaHeight || 220,
                                textAlign: 'center',
                                objectFit,
                                position: 'relative',
                                marginBottom: 2,
                            }}
                        />
                        <FormHelperText error sx={{ textAlign: 'center', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                            {label ? label : recommendedText}
                        </FormHelperText>
                        <FormHelperText sx={{ textAlign: 'center', width: '100%', alignItems: 'center', justifyContent: 'center', color: 'text.secondary' }}>
                            {tipText}
                        </FormHelperText>
                        <Stack direction="row" mt={2} columnGap={2}>
                            <Button variant="text" onClick={handleOpen}>
                                Trocar imagem
                            </Button>
                            {!required && (
                                <Button
                                    variant="text"
                                    onClick={() => {
                                        onChange('previewImage', null);
                                        onChange(name, null);
                                    }}
                                >
                                    Remover imagem
                                </Button>
                            )}
                        </Stack>
                    </>
                ) : (
                    <>
                        <Box
                            sx={{
                                border: 'dashed 2px #ccc',
                                borderRadius: 1,
                                width: canvaWidth || 300,
                                height: canvaHeight || 220,
                                justifyContent: 'center',
                                alignItems: 'center',
                                display: 'flex',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                            }}
                        ></Box>
                        <FormHelperText error sx={{ textAlign: 'center', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                            {label ? label : recommendedText}
                        </FormHelperText>
                        <FormHelperText sx={{ textAlign: 'center', width: '100%', alignItems: 'center', justifyContent: 'center', color: 'text.secondary' }}>
                            {tipText}
                        </FormHelperText>
                        <Stack direction="row" mt={2} columnGap={2}>
                            <Button variant="outlined" onClick={handleOpen}>
                                Adicionar imagem
                            </Button>
                        </Stack>
                    </>
                )}
            </Stack>

            <TextField
                inputRef={refInputFile}
                type="file"
                id="file"
                multiple={false}
                accept="image/jpeg,image/png,image/jpg"
                name="logo"
                onChange={e => handleFile(e.target.files[0])}
                style={{ display: 'none' }}
            />

            <Dialog
                open={Boolean(preview)}
                onClose={() => {
                    setPreview();
                    setImage();
                }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>Pré-visualização</DialogTitle>
                <Divider />
                <DialogContent sx={{ textAlign: 'center' }}>
                    <Box
                        sx={{ maxHeight: canvaHeight * 2.5, maxWidth: canvaWidth * 2.5, objectFit: 'cover', objectPosition: 'center' }}
                        component="img"
                        src={preview}
                    />
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        onClick={() => {
                            setPreview();
                            setImage();
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            onChange('previewImage', preview);
                            onChange(name, image);
                            setPreview();
                            setImage();
                        }}
                    >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>
        </Stack>
    );
}
